import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from 'components/Icon';
import Flag from 'components/Flag';
import VisuallyHidden from 'components/VisuallyHidden';
function CurationItem(_ref) {
  var children = _ref.children,
    isComplete = _ref.isComplete;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var iconName = isComplete ? 'ok' : 'warning';
  var color = isComplete ? 'positive' : 'negative';
  return /*#__PURE__*/React.createElement(Flag, {
    spacing: "xs",
    align: "top",
    token: /*#__PURE__*/React.createElement(Icon, {
      vAlign: true,
      name: iconName,
      color: color
    })
  }, children, /*#__PURE__*/React.createElement(VisuallyHidden, null, ' ', t(isComplete ? 'property_present_brackets' : 'property_missing_brackets')));
}
export default CurationItem;